import { n as navScroll, r as resetSecondaryMenu, a as switchContent, m as mobileAccordions } from "./utilities-nav-utils.js";
import { m as mediaQueries } from "./utilities-utils.js";
import { c as closeAllToggletips } from "./utilities-toggletip-engine.js";
import "./utilities-overlay.js";
import "./floating-ui.js";
class NavigationMain extends HTMLElement {
  connectedCallback() {
    this.headerEl = document.getElementById("nav-wrapper");
    this.navigationItems = this.querySelectorAll("toggletip-engine");
    this.ux = this.dataset.ux;
    this.uxPosition = this.dataset.uxPosition;
    this.transparent = this.dataset.transparent;
    this.headerEl.props = {};
    this.headerEl.props.navMargin = 0;
    this.headerEl.props.transformAmount = 0;
    this.headerEl.props.lastScroll = window.scrollY;
    this.headerEl.props.submenuOpen = false;
    this.headerEl.props.activeMenu = 0;
    this.resetHeader();
    if (this.uxPosition === "off" || this.uxPosition === "hide") {
      this.observeStickySubheader();
    }
    if (this.uxPosition !== "off") {
      window.addEventListener("scroll", this.handleScroll);
      this.handleScroll();
    }
    this.resetOnResize();
    this.enableNavUX();
    if (this.transparent === "true") {
      window.addEventListener("resize", this.resizeHandler);
    }
  }
  // Add disconnectedCallback to clean up the event listener
  disconnectedCallback() {
    if (this.transparent === "true") {
      window.removeEventListener("resize", this.resizeHandler);
    }
  }
  // resets the header to default by removing navScroll utility changes
  resetHeader = () => {
    this.headerEl.classList.remove("header-visible");
    this.headerEl.classList.remove("sticky-active");
    this.headerEl.classList.remove("reached-top");
    this.headerEl.style.marginTop = "";
  };
  handleScroll = () => {
    navScroll(this.headerEl, this.uxPosition);
  };
  enableNavUX() {
    if (this.uxPosition === "fixed") {
      this.headerEl.classList.add("sticky");
    } else {
      this.headerEl.classList.remove("sticky");
    }
    const applyHoverWithGracePeriod = (triggerElement) => {
      let closeTimer;
      const dropdown = triggerElement.querySelector("[data-tooltip]");
      const focusableElement = triggerElement.querySelector("[data-tooltip-trigger]") || triggerElement;
      const openMenu = () => {
        if (closeTimer) clearTimeout(closeTimer);
        if (triggerElement.classList.contains("toggletip-parent")) {
          handleParentToggletip(triggerElement, "open");
        } else {
          closeAllToggletips(true, triggerElement);
          triggerElement.open();
        }
      };
      const startCloseTimer = () => {
        closeTimer = setTimeout(() => {
          if (triggerElement.classList.contains("toggletip-parent")) {
            handleParentToggletip(triggerElement, "close");
          } else {
            triggerElement.close();
          }
        }, 150);
      };
      triggerElement.addEventListener("mouseenter", openMenu);
      triggerElement.addEventListener("mouseleave", startCloseTimer);
      focusableElement.addEventListener("focus", (e) => {
        openMenu();
      });
      focusableElement.addEventListener("blur", (e) => {
        setTimeout(() => {
          const activeElement = document.activeElement;
          const isWithinToggletip = triggerElement.contains(activeElement) || triggerElement.querySelector("[data-tooltip]") && triggerElement.querySelector("[data-tooltip]").contains(activeElement);
          if (!isWithinToggletip) {
            startCloseTimer();
          }
        }, 50);
      });
      focusableElement.addEventListener("keydown", (e) => {
        if (e.key === " ") {
          e.preventDefault();
          openMenu();
        } else if (e.key === "Enter") ;
      });
      if (dropdown) {
        dropdown.addEventListener("mouseenter", () => {
          if (closeTimer) clearTimeout(closeTimer);
        });
        dropdown.addEventListener("mouseleave", startCloseTimer);
      }
    };
    const handleParentToggletip = (toggletip, action) => {
      if (action === "open") {
        closeAllToggletips(true, toggletip);
        toggletip.open();
      } else if (action === "close") {
        const activeChild = toggletip.querySelector('.toggletip-child[open="true"]');
        if (!activeChild) {
          toggletip.close();
        }
      }
    };
    const handleChildToggletip = (toggletip, parentToggletip, action) => {
      if (!parentToggletip) return;
      if (action === "open") {
        const siblings = parentToggletip.querySelectorAll(".toggletip-child");
        siblings.forEach((sibling) => {
          if (sibling !== toggletip && sibling.isOpen) {
            sibling.close();
          }
        });
        toggletip.open();
      } else if (action === "close") {
        toggletip.close();
      }
    };
    const getParentToggletip = (element) => {
      return element.closest("[data-tooltip]")?.closest("toggletip-engine");
    };
    const setupToggletipEvents = (navigationMenuItem, eventType2) => {
      if (navigationMenuItem.classList.contains("toggletip-parent")) {
        if (eventType2 === "click") {
          navigationMenuItem.addEventListener("click", (e) => {
            e.stopPropagation();
            const clickedToggletip = e.target.closest("toggletip-engine");
            if (!clickedToggletip) return;
            const action = navigationMenuItem.isOpen ? "close" : "open";
            handleParentToggletip(navigationMenuItem, action);
          });
        } else {
          applyHoverWithGracePeriod(navigationMenuItem);
        }
      } else if (navigationMenuItem.classList.contains("toggletip-child")) {
        const handleChildToggle = (e) => {
          e.stopPropagation();
          const clickedToggletip = e.target.closest("toggletip-engine");
          if (!clickedToggletip) return;
          const parentToggletip = getParentToggletip(clickedToggletip);
          const action = clickedToggletip.isOpen ? "close" : "open";
          handleChildToggletip(clickedToggletip, parentToggletip, action);
        };
        const childFocusableElement = navigationMenuItem.querySelector("[data-tooltip-trigger]") || navigationMenuItem;
        if (eventType2 === "click") {
          navigationMenuItem.addEventListener("click", handleChildToggle);
          childFocusableElement.addEventListener("keydown", (e) => {
            if (e.key === " ") {
              e.preventDefault();
              handleChildToggle(e);
            } else if (e.key === "Enter") ;
          });
        } else {
          navigationMenuItem.addEventListener("mouseenter", () => {
            const parentToggletip = getParentToggletip(navigationMenuItem);
            handleChildToggletip(navigationMenuItem, parentToggletip, "open");
          });
          navigationMenuItem.addEventListener("mouseleave", () => {
            handleChildToggletip(navigationMenuItem, null, "close");
          });
          const childFocusableElement2 = navigationMenuItem.querySelector("[data-tooltip-trigger]") || navigationMenuItem;
          childFocusableElement2.addEventListener("focus", () => {
            const parentToggletip = getParentToggletip(navigationMenuItem);
            handleChildToggletip(navigationMenuItem, parentToggletip, "open");
          });
          childFocusableElement2.addEventListener("blur", () => {
            setTimeout(() => {
              const activeElement = document.activeElement;
              const isWithinChildToggletip = navigationMenuItem.contains(activeElement) || navigationMenuItem.querySelector("[data-tooltip]") && navigationMenuItem.querySelector("[data-tooltip]").contains(activeElement);
              if (!isWithinChildToggletip) {
                handleChildToggletip(navigationMenuItem, null, "close");
              }
            }, 50);
          });
        }
      } else {
        const isSearchTrigger = navigationMenuItem.querySelector(".search-trigger");
        const isMenuTrigger = navigationMenuItem.querySelector(".menu-trigger");
        if (isSearchTrigger || isMenuTrigger) {
          const handleToggle = (e) => {
            e.stopPropagation();
            if (navigationMenuItem.isOpen) {
              navigationMenuItem.close();
            } else {
              closeAllToggletips(true, navigationMenuItem);
              navigationMenuItem.open();
            }
          };
          navigationMenuItem.addEventListener("click", handleToggle);
          navigationMenuItem.addEventListener("keydown", (e) => {
            if (e.key === " ") {
              e.preventDefault();
              handleToggle(e);
            }
          });
        } else if (eventType2 === "hover") {
          applyHoverWithGracePeriod(navigationMenuItem);
        }
      }
    };
    const eventType = this.ux === "click" ? "click" : "hover";
    this.navigationItems.forEach((navigationMenuItem) => {
      setupToggletipEvents(navigationMenuItem, eventType);
    });
    document.addEventListener("focusin", (e) => {
      const focusedElement = e.target;
      const openToggletips = this.querySelectorAll('toggletip-engine [data-tooltip-trigger][open="true"]');
      let isWithinOpenToggletip = false;
      for (const trigger of openToggletips) {
        const toggletip = trigger.closest("toggletip-engine");
        if (!toggletip) continue;
        if (toggletip.contains(focusedElement)) {
          isWithinOpenToggletip = true;
          break;
        }
        const dropdown = toggletip.querySelector("[data-tooltip]");
        if (dropdown && dropdown.contains(focusedElement)) {
          isWithinOpenToggletip = true;
          break;
        }
      }
      if (this.contains(focusedElement) && !isWithinOpenToggletip) {
        closeAllToggletips();
      }
    });
    if (this.ux === "click") {
      this.closest(".shopify-section").addEventListener("click", () => {
        closeAllToggletips();
      });
    }
    this.querySelectorAll(".nav").forEach((nav) => {
      resetSecondaryMenu(nav);
    });
    this.querySelectorAll(".nav").forEach((el) => {
      el.props = {};
      const firstButton = el.querySelector(".nav__main-menu-link");
      const firstContent = firstButton?.parentNode.querySelector(".nav__secondary-menu__item");
      const navContent = this.querySelector(".nav--multilevel .nav__content");
      if (firstContent && navContent) {
        const contentHeight = firstContent.getBoundingClientRect().height;
        navContent.style.height = contentHeight + "px";
      }
      el.querySelectorAll(".nav__main-menu-link").forEach((button, index) => {
        if (window.matchMedia("(hover: hover)").matches) {
          if (mediaQueries.isLargeUp.matches) {
            button.addEventListener("mouseover", () => {
              switchContent(button, el);
            });
          }
        }
        button.addEventListener("focus", () => {
          switchContent(button, el);
        });
        button.addEventListener("click", () => {
          el.classList.add("nav--secondary-menu-open");
          switchContent(button, el);
          const targetMenu = button.getAttribute("data-targetmenu");
          el.querySelector(`#${targetMenu}`);
          const innerContainer = el.querySelector(".nav--mobile__inner-container");
          if (el.classList.contains("nav--mobile")) {
            const scroller = innerContainer || el.querySelector(".container");
            if (scroller) {
              requestAnimationFrame(() => {
                scroller.scrollTop = 0;
                scroller.scrollLeft = 0;
                if (typeof scroller.scrollTo === "function") {
                  scroller.scrollTo({ top: 0, left: 0, behavior: "auto" });
                }
              });
            }
          }
        });
      });
      el.querySelectorAll(".nav__secondary-menu__close").forEach((button) => {
        button.addEventListener("click", () => {
          resetSecondaryMenu(el);
        });
      });
      mobileAccordions(el);
    });
  }
  observeStickySubheader() {
    const stickySubheader = document.querySelector(".sticky-subheader");
    if (!stickySubheader) return;
    stickySubheader.props = { isStuck: false };
    const observer = new IntersectionObserver(
      ([e]) => {
        const isStuck = e.intersectionRatio < 1;
        e.target.classList.toggle("sticky--stuck", isStuck);
        const shouldUpdate = e.target.props.isStuck !== isStuck;
        if (shouldUpdate) e.target.props.isStuck = isStuck;
      },
      { threshold: [1] }
    );
    observer.observe(stickySubheader);
  }
  // reset stuff when resizing from desktop to mobile
  resetOnResize() {
    mediaQueries.isLargeDown.addEventListener("change", () => {
      closeAllToggletips();
      if (mediaQueries.isLargeDown.matches) {
        this.headerEl.style.marginTop = 0;
        this.headerEl.props.navMargin = 0;
      }
    });
  }
  handleTransparentHeader() {
    if (this.transparent === "true") {
      const navWrapper = this.closest("#nav-wrapper") || document.getElementById("nav-wrapper");
      if (!navWrapper) return;
      const headerHeight = navWrapper.offsetHeight + 1;
      const mainElement = document.querySelector("main");
      if (mainElement) {
        mainElement.style.setProperty("--header-height", `${headerHeight}px`);
        mainElement.style.marginTop = `calc(-1 * var(--header-height))`;
      }
    } else {
      const mainElement = document.querySelector("main");
      if (mainElement) {
        mainElement.style.marginTop = "";
      }
      const shopifySection = this.closest(".shopify-section");
      const navWrapper = this.closest("#nav-wrapper");
      shopifySection?.classList.remove("is-transparent");
      navWrapper?.classList.remove("has-background");
    }
  }
  handleCartDrawer() {
    if (this.cartOpenButtons) {
      this.cartOpenButtons.forEach((button) => {
        button.addEventListener("click", () => {
          closeAllToggletips(true);
          this.cartDrawer.open();
        });
      });
    }
  }
  disconnectedCallback() {
    if (this.uxPosition !== "off") {
      window.removeEventListener("scroll", this.handleScroll);
    }
    if (this.transparent === "true") {
      window.removeEventListener("resize", this.resizeHandler);
    }
  }
  // Simple debounce utility scoped to the instance
  _debounce(fn, wait) {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
if (!window.customElements.get("main-nav")) {
  window.customElements.define("main-nav", NavigationMain);
}
